import { render, staticRenderFns } from "./FbVisioTab.vue?vue&type=template&id=39a46e90"
import script from "./FbVisioTab.vue?vue&type=script&lang=ts"
export * from "./FbVisioTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports